
import Vue from "vue"
import { vMaska } from "maska/dist/vue"
import type { Maskito } from "@maskito/core"
import fieldMixin from "@/mixins/field"
import { getPhoneMaskOpts } from "@/utils/mask"

Vue.directive("maska", vMaska)

export default fieldMixin.extend({
  props: {
    mask: { type: String, default: null },
  },

  data () {
    return {
      passwordType: this.$attrs.type === "password"
        ? "password"
        : undefined,

      maskito: null as Maskito | null,
    }
  },

  computed: {
    adaptedPlaceholder (): string {
      const { placeholder, $attrs: { type } } = this
      if (placeholder) return placeholder
      if (type === "email") return "user@example.com"
      if (type === "tel") return this.$i18n.locale === "ru"
        ? "+7 999 999-99-99"
        : "+1 111 111-11-11"
      if (type === "url") return "https://example.com"
      // if (label) return label
      // return this.$t("form.enter") as string
      return ""
    },
  },

  created () {
    this.onChange()
  },

  mounted () {
    if (this.$attrs.type === "tel")
      setTimeout(() => {
        this.setPhoneMask()
      }, 1000)
  },

  beforeDestroy () {
    this.maskito?.destroy()
  },

  methods: {
    onChange () {
      const { model, $attrs: { type } } = this
      if (type === "url") {
        if (model && typeof model === "string" && !model.startsWith("http"))
          this.model = `http://${model}`
      } else if (type === "number") {
        if (typeof model !== "number") {
          const numberModel = Number(model)
          this.model = Number.isNaN(numberModel) ? undefined : numberModel
        }
      }
    },

    togglePassword () {
      this.passwordType = this.passwordType === "password"
        ? "text"
        : "password"
    },

    async setPhoneMask () {
      const inputRef = this.$refs.inputRef as HTMLInputElement
      if (!inputRef) return

      const opts = await getPhoneMaskOpts()

      const { Maskito } = await import("@maskito/core")

      this.maskito = new Maskito(inputRef, opts)
    },
  },
})
